<!-- 培训详情 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="content">
      <div class="title">{{ detail.title }}</div>
      <div class="detail" v-if="videoTypes.includes(detail.fileType)">
        <video class="video" :src="detail.contentStr" controls></video>
      </div>
      <div class="detail" v-if="detail.fileType == 'pdf'">
        <iframe
          :src="
            'http://www.scjxrc.org.cn/static/pdf/viewer.html?file=' +
            detail.contentStr
          "
          frameborder="0"
        ></iframe>
      </div>
      <div class="detail" v-if="pptTypes.includes(detail.fileType)">
        <iframe
          :src="
            'https://view.officeapps.live.com/op/embed.aspx?src=' +
            detail.contentStr
          "
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/breadCrumb.vue";
import { URL } from "../util/config";
export default {
  components: { Breadcrumb },
  data() {
    return {
      URL,
      breadcrumbs: [],
      detail: {},
      videoTypes: [
        "swf",
        "avi",
        "flv",
        "mpg",
        "rm",
        "mov",
        "wav",
        "asf",
        "3gp",
        "mkv",
        "rmvb",
        "mp4",
      ],
      pptTypes: ["ppt", "pptx"],
    };
  },
  created() {
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { path: "/train", name: "在线培训" },
    ];
    this.$api.getNewDetail({ id: this.$route.params.id }).then((res) => {
      this.breadcrumbs.push({ name: res.data.title });
      let data = res.data;
      const arr = data.contentStr.split(".");
      data.fileType = arr[arr.length - 1];
      data.contentStr = this.URL + data.contentStr;
      this.detail = data;
      console.log(this.detail.fileType);
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.frame {
  width: 100%;
}
.video {
  max-width: 100%;
  height: auto;
}
.content {
  padding: 30px 0;

  .title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .info {
    text-align: center;
    font-size: 13px;
    color: #999;

    span + span {
      margin-left: 20px;
    }
  }
  .detail {
    width: 1200px;
    min-height: 50vh;
    margin: 40px auto 0;

    iframe {
      width: 100%;
      height: 80vh;
    }
  }
}
</style>
